import { MAX_ACCELERATOR_DURATION, MINIMUM_TIMER_INCREMENT } from '@/constants';
import Accelerator from "@/mixins/accelerator";

export default {
	actions: {
		startAccelerator(context, payload) {
			const duration = context.getters.maxDuration(payload.acceleratorList.length);
			const isLinear = duration !== MAX_ACCELERATOR_DURATION;

			context.dispatch("accelerator", {
				Accelerator: new Accelerator(payload.acceleratorList, duration, isLinear),
				action: payload.action,
				fallbackAction: payload.fallbackAction,
				completionAction: payload.completionAction,
			});
		},
		accelerator(context, payload) {
			context.commit("addTimer", {
				duration: payload.Accelerator.getInterval(),
				ref: "accelerator",
				payload: {
					Accelerator: payload.Accelerator,
					action: payload.action,
					fallbackAction: payload.fallbackAction,
					completionAction: payload.completionAction,
				},
				action: (timerPayload) => {
					context.dispatch(timerPayload.action, timerPayload.Accelerator.getItem());

					const hasItems = timerPayload.Accelerator.hasItems();

					if (timerPayload.timer.duration < MINIMUM_TIMER_INCREMENT && hasItems) {
						context.dispatch("completeAcceleratorImmediately", timerPayload);
					} else if (hasItems) {
						context.dispatch("accelerator", timerPayload);
					} else if (timerPayload.completionAction) {
						context.dispatch(timerPayload.completionAction);
					}
				},
			});
		},
		completeAcceleratorImmediately(context, payload) {
			function iterateImmediately() {
				context.dispatch(payload.action, payload.Accelerator.getItem());

				if (payload.Accelerator.hasItems()) {
					requestAnimationFrame(iterateImmediately);
				} else if (payload.completionAction) {
					requestAnimationFrame(() => {
						context.dispatch(payload.completionAction);
					});
				}
			}

			requestAnimationFrame(iterateImmediately);
		},
	},
	getters: {
		maxDuration() {
			return count => Math.min((count * 250), MAX_ACCELERATOR_DURATION);
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/accelerator.js